<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-notes-medical"></i> Consulta
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Consulta*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Telefone</label>
                                    <masked-input
                                        v-model.trim="model.telefone"
                                        mask="(11) 11111-1111"
                                        class="form-control"
                                    ></masked-input>
                                </div>
                                <div :class="{'has-danger': $v.model.data.$error }">
                                    <label>Data*</label>
                                    <flat-pickr
                                        v-model="model.data"
                                        :config="config"
                                        class="form-control"
                                        placeholder="Selecione"
                                        name="date"
                                    ></flat-pickr>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Veterinário</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.veterinario"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>CRMV/CBCK</label>
                                    <input
                                        type="text"
                                        maxlength="5"
                                        class="form-control"
                                        v-model="model.numeroInscricao"
                                    />
                                </div>
                                <div class="col-md-3 align-self-center">
                                    <label>Realizada?*</label>
                                    <br />
                                    <input-toggle
                                        v-model="model.realizado"
                                        :value="model.realizado"
                                    ></input-toggle>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Observação</label>
                                    <textarea
                                        rows="5"
                                        cols="50"
                                        type="text"
                                        maxlength="1000"
                                        class="form-control"
                                        v-model="model.observacao"
                                    />
                                </div>

                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.preco.$error }"
                                >
                                    <label>Preço R$*</label>
                                    <money v-model="model.preco" class="form-control"></money>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{name: 'list-consultation-pet', params: { id: this.$route.params.id}}"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty,
    formatPhone
} from "@/services/string";
import { isPhone } from "@/services/util";
import Collections from "@/helpers/collections";
import Select2 from "../../../components/Input/Select2";
import FileImage from "../../../components/Input/FileImage";
import SelectApi from "../../../components/Input/SelectApi";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

export default {
    components: { Select2, FileImage, SelectApi, flatPickr, isPhone },
    data() {
        return {
            model: {
                id: null,
                idPet: null,
                veterinario: "",
                nome: "",
                data: "",
                numeroInscricao: "",
                observacao: "",
                preco: 0.0,
                telefone: "",
                realizado: false
            },
            file: null,
            config: {
                wrap: true,
                enableTime: true,
                time_24hr: true,
                locale: Portuguese,
                altInput: true,
                altFormat: "d/m/Y H:i",
                allowInput: true
            }
        };
    },
    validations() {
        return {
            model: {
                data: {
                    required
                },
                nome: {
                    required,
                    minLength: minLength(2)
                },
                preco: {
                    required
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;

            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);
            vm.model.idPet = this.$route.params.id;

            if (vm.model.id) {
                let ret = facade.updateConsultation(vm.model, vm.model.id);
                ret.then(consultation => {
                    this.$router.push({
                        name: "list-consultation-pet",
                        params: {
                            id: this.$route.params.id,
                            idconsultation: this.$route.params.idconsultation
                        }
                    });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            } else {
                try {
                    let ret = facade.createConsultation(vm.model);
                    ret.then(consultation => {
                        this.$router.push({
                            name: "list-consultation-pet",
                            params: {
                                id: this.$route.params.id,
                                idConsultation: this.$route.params.id
                            }
                        });
                        this.$loading.show(false);
                    }).catch(e => {
                        e.forEach(item => {
                            this.$notify.error(item.field, item.message);
                        });
                        this.$loading.show(false);
                    });
                } catch (e) {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                }
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(consultation) {
            let vm = this;
            if (consultation !== undefined && consultation !== null) {
                consultation.telefone = consultation.telefone
                    ? formatPhone(consultation.telefone)
                    : "";
                this.model = consultation;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([
            to.params.idConsultation
                ? facade.getConsultation(to.params.idConsultation)
                : null
        ])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?51ccbec8